import { observer } from 'mobx-react'

import { SelectField } from '@avantstay/backoffice-core'

import { storeHolder } from '@new/__global/components/FastTapeChart/stores/TapeChartStore'
import { HotelTapeChartStore } from '@new/domains/hotelTapeChart/stores/HotelTapeChartStore'

import { UnitsSorting } from '../../config/contants'

const unitsSortingOptions = [
  { label: 'Rank (Recommended)', value: UnitsSorting.RANK },
  { label: 'Room/Unit Number', value: UnitsSorting.UNIT_NUMBER },
]

const _UnitsSortingSelect = () => {
  const { filterStore } = storeHolder.store as HotelTapeChartStore
  const { sortUnitsBy, setSortUnitsBy } = filterStore

  return (
    <SelectField.Small
      removeBorder
      removeBackground
      menuPosition="fixed"
      menuWidth="160px"
      isSearchable={false}
      options={unitsSortingOptions}
      value={unitsSortingOptions.find(option => option.value === sortUnitsBy)}
      onChange={mode => setSortUnitsBy(mode.value)}
    />
  )
}

export const UnitsSortingSelect = observer(_UnitsSortingSelect)
